import { Component, EventEmitter, Input, Output } from '@angular/core';
import { EmptyStateType } from '../../../../../../../common-modules/components/components/empty-state/empty-state.component';

@Component({
    selector: 'app-finished-questionnaire',
    templateUrl: './finished-questionnaire.component.html',
    styleUrls: ['./finished-questionnaire.component.scss'],
    standalone: false,
})
export class FinishedQuestionnaireComponent {
    @Input() type: 'mandatory_questions_finished' | 'entire_questionnaire_finished';
    @Input() imgType: EmptyStateType;
    @Output() resumeQuestionnaire = new EventEmitter<{
        status: boolean;
        type: 'start' | 'resume';
        isContinue?: boolean;
    }>();

    constructor() {}

    public onResumeQuestionnaire($event: any) {
        if (this.type === 'mandatory_questions_finished') {
            this.resumeQuestionnaire.emit({ status: true, type: 'resume', isContinue: true });
        } else {
            this.resumeQuestionnaire.emit({ status: true, type: 'start' });
        }
    }
}
